
import React, { useState } from 'react'
import Layout from '../components/layout'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Form } from 'react-bootstrap'


import S1 from '../assets/files/FCE - SIN - 01 - DENUNCIA DE SINIESTRO POR FALLECIMIENTO - ART_ 248 LCT.pdf'
import S2 from '../assets/files/FCE - SIN - 02 - DENUNCIA DE SINIESTRO POR INVALIDEZ - ART_ 212 LCT.pdf'
import S3 from '../assets/files/FCE - SIN - 03 - ENFERMEDAD Y-O ACCIDENTE INCULPABLE.pdf'
import S4 from '../assets/files/FCE - SIN - 04 - DENUNCIA DE SINIESTRO POR FALLECIMIENTO.pdf'
import S5 from '../assets/files/FCE - SIN - 05 - DENUNCIA DE SINIESTRO POR DESEMPLEO.pdf'
import S6 from '../assets/files/FCE - SIN - 06 - UIF - PERSONA HUMANA.pdf'
import S7 from '../assets/files/FCE - SIN - 07 - UIF - PERSONAS JURIDICAS.pdf'
import S8 from '../assets/files/FCE - SIN - 08 - DENUNCIA DE SINIESTRO POR MATERNIDAD.pdf'
import S9 from '../assets/files/FCE - SIN - 09 - SEGURO COLECTIVO DE VIDA OBLIGATORIO.pdf'
import S10 from '../assets/files/FCE - SIN - 10 - INFORMACION POR SINIESTRO RG 126 - 2023 - UIF.pdf'
import S11 from '../assets/files/FCE - SIN - 11 - DENUNCIA DE SINIESTRO SEGUROS DE PERSONAS.pdf'
import S12 from '../assets/files/FCE - SIN - 12 - DENUNCIA DE SINIESTRO DE VIDA CON AHORRO.pdf'
import S13 from '../assets/files/FCE - SIN - 13 - DECLARACION JURADA DEL BENEFICIARIO - CESIONARIO.pdf'

import I1 from '../assets/files/FCE - INV - 01 - SOLICITUD DE RESCATE - VIDA CON AHORRO.pdf'

import E1 from '../assets/files/FCE - EMI - 01 - DECLARACION JURADA PERSONA POLITICAMENTE EXPUESTA_V02.pdf'
import E2 from '../assets/files/FCE - EMI - 02 - ASEGURADOS TOMADORES RG 126_2023 - U.I.F._V02.pdf'
import E3 from '../assets/files/FCE - EMI - 03 - TOMADORES ASEGURADOS RG 126_2023 - U.I.F. - PERSONAS JURIDICAS_PRINCIPAL.pdf'
import E3A from '../assets/files/FCE - EMI - 03 - TOMADORES ASEGURADOS RG 126_2023 - U.I.F. - PERSONAS JURIDICAS - ANEXO.pdf'
import E4 from '../assets/files/FCE - EMI - 04 - INFORMACION A ASEGURADOS RG 126-2023 U.I.F. - ORGANISMOS PUBLICOS.pdf'
import E5 from '../assets/files/FCE - EMI - 05 - FORMULARIO DE BENEFICIARIOS.pdf'
import E6 from '../assets/files/FCE - EMI - 06 - SEGURO DE VIDA OBLIGATORIO - SOLICITUD DE POLIZA.pdf'
import E7 from '../assets/files/FCE - EMI - 07 - SCV - ADHESION Y DESIGNACION DE BENEFICIARIOS.pdf'
import E8 from '../assets/files/FCE - EMI - 08 - DDJJ SUJETO OBLIGADO - RESOLUCION 126-2023 U.I.F..pdf'
import E12 from '../assets/files/FCE - EMI - 12 - SOLICITUD AFILIACION VIDA CON AHORRO.pdf'
import E15 from '../assets/files/FCE - EMI - 15 - DECLARACION JURADA DEL PAGADOR DE LA POLIZA.pdf'

library.add(fas)

const Div = styled.div`

    background: #f7f8fa;
    min-height: 100%;


    /* ==============================
       CONTENEDOR
    ============================== */

    .forms-container {
        max-width: 1100px;
        margin: 0 auto;
        padding: 65px 25px 80px;
    }


    /* ==============================
       HEADER
    ============================== */

    .forms-header {
        text-align: center;
        margin-bottom: 40px;
    }

    .forms-eyebrow {
        display: block;

        margin-bottom: 8px;

        color: #E85A20;

        font-size: 12px;
        font-weight: 700;

        letter-spacing: 3px;
        text-transform: uppercase;
    }

    .forms-header h2 {
        margin: 0;

        color: #102B50;

        font-size: 40px;
        font-weight: 700;
    }

    .forms-line {
        width: 50px;
        height: 4px;

        margin: 16px auto;

        background: #E85A20;

        border-radius: 5px;
    }

    .forms-header p {
        max-width: 650px;

        margin: 0 auto;

        color: #687586;

        font-size: 16px;
        line-height: 1.6;
    }


    /* ==============================
       INFORMACIÓN IMPORTANTE
    ============================== */

    .forms-important {
        display: flex;
        gap: 20px;

        margin-bottom: 45px;
        padding: 25px 30px;

        background: #ffffff;

        border-left: 4px solid #E85A20;
        border-radius: 6px;

        box-shadow: 0 5px 20px rgba(20, 40, 60, 0.06);
    }

    .important-icon {
        flex-shrink: 0;

        width: 42px;
        height: 42px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 50%;

        background: #fff1eb;

        color: #E85A20;

        font-size: 18px;
    }

    .forms-important-content strong {
        color: #102B50;
    }

    .forms-important-content p {
        margin: 0 0 10px;

        color: #526274;

        font-size: 14px;
        line-height: 1.6;
    }

    .forms-important-content p:last-of-type {
        margin-bottom: 8px;
    }

    .forms-important-content ul {
        margin: 0;
        padding-left: 20px;

        color: #526274;

        font-size: 14px;
        line-height: 1.7;
    }


    /* ==============================
       GRID
    ============================== */

    .forms-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 25px;
    }


    /* ==============================
       CARD
    ============================== */

    .form-card {
        position: relative;

        padding: 32px;

        background: #ffffff;

        border: 1px solid #e5e9ed;
        border-radius: 10px;

        box-shadow: 0 7px 25px rgba(20, 40, 60, 0.06);

        transition: all 0.25s ease;
    }

    .form-card:hover {
        transform: translateY(-3px);

        box-shadow: 0 12px 30px rgba(20, 40, 60, 0.10);
    }


    /* línea superior */

    .form-card::before {
        content: "";

        position: absolute;

        top: 0;
        left: 0;

        width: 100%;
        height: 4px;

        background: #E85A20;

        border-radius: 10px 10px 0 0;
    }


    /* número */

    .form-number {
        color: #c8ced5;

        font-size: 12px;
        font-weight: 700;

        letter-spacing: 1px;
    }


    .form-card h3 {
        margin: 8px 0 6px;

        color: #102B50;

        font-size: 24px;
        font-weight: 700;
    }

    .form-card-description {
        margin-bottom: 22px;

        color: #7a8795;

        font-size: 14px;
    }


    /* ==============================
       SELECT
    ============================== */

    .form-select-label {
        display: block;

        margin-bottom: 8px;

        color: #26384d;

        font-size: 13px;
        font-weight: 600;
    }

    .form-card select {
        width: 100%;
        height: 45px;

        padding: 0 12px;

        border: 1px solid #d5dbe1;
        border-radius: 5px;

        background: #ffffff;

        color: #526274;

        font-size: 14px;

        outline: none;
    }

    .form-card select:focus {
        border-color: #E85A20;

        box-shadow: 0 0 0 2px rgba(232, 90, 32, 0.10);
    }


    /* ==============================
       BOTÓN
    ============================== */

    .download-button {
        width: 100%;

        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;

        margin-top: 15px;
        padding: 12px;

        border: none;
        border-radius: 5px;

        background: #E85A20;

        color: #ffffff;

        font-size: 14px;
        font-weight: 600;

        text-decoration: none;

        transition: all 0.2s ease;
    }

    .download-button:hover {
        background: #d94f19;

        color: #ffffff;

        text-decoration: none;
    }

    .download-button.disabled {
        background: #d9dde1;

        color: #8a939d;

        cursor: not-allowed;

        pointer-events: none;
    }


    /* ==============================
       TERCERA TARJETA
    ============================== */

    .form-card-wide {
        grid-column: 1 / -1;
    }

    .form-card-wide .form-card-inner {
        max-width: 650px;
        margin: 0 auto;
    }


    /* ==============================
       MOBILE
    ============================== */

    @media screen and (max-width: 768px) {

        .forms-container {
            padding: 45px 18px 60px;
        }

        .forms-header h2 {
            font-size: 34px;
        }

        .forms-grid {
            grid-template-columns: 1fr;
        }

        .form-card-wide {
            grid-column: auto;
        }

        .forms-important {
            padding: 22px;
        }

    }

    @media screen and (max-width: 500px) {

        .forms-important {
            gap: 12px;
        }

        .important-icon {
            width: 36px;
            height: 36px;
        }

        .form-card {
            padding: 27px 22px;
        }

    }

`;


export default function Forms() {

    const [formsS, setFormsS] = useState('');
    const [formsI, setFormsI] = useState('');
    const [formsE, setFormsE] = useState('');


    return (
        <Layout>

            <Div>

                <div className="forms-container">


                    {/* ==============================
                        HEADER
                    ============================== */}

                    <div className="forms-header">

                        <span className="forms-eyebrow">
                            Documentación
                        </span>

                        <h2>
                            Formularios
                        </h2>

                        <div className="forms-line"></div>

                        <p>
                            Descargá los formularios que necesitás
                            y completalos de manera sencilla.
                        </p>

                    </div>


                    {/* ==============================
                        IMPORTANTE
                    ============================== */}

                    <div className="forms-important">

                        <div className="important-icon">
                            <FontAwesomeIcon icon="exclamation" />
                        </div>

                        <div className="forms-important-content">

                            <p>
                                <strong>IMPORTANTE:</strong>{' '}
                                Los formularios pueden editarse digitalmente.
                            </p>

                            <p>
                                La entrega del formulario debe efectuarse:
                            </p>

                            <ul>
                                <li>En digital</li>
                                <li>Debe estar impreso en doble faz</li>
                                <li>
                                    Debe presentarse debidamente firmado
                                    sin tachaduras ni enmiendas
                                </li>
                            </ul>

                        </div>

                    </div>


                    {/* ==============================
                        FORMULARIOS
                    ============================== */}

                    <div className="forms-grid">


                        {/* SINIESTROS */}

                        <div className="form-card">

                            <span className="form-number">
                                01
                            </span>

                            <h3>
                                Siniestros
                            </h3>

                            <p className="form-card-description">
                                Formularios para denuncias y trámites
                                relacionados con siniestros.
                            </p>

                            <label className="form-select-label">
                                Seleccioná un formulario
                            </label>

                            <Form.Control
                                as="select"
                                value={formsS}
                                onChange={(e) => setFormsS(e.target.value)}
                            >

                                <option value="">
                                    Seleccioná una opción...
                                </option>

                                <option value={S1}>
                                    Fallecimiento - Art. 248 LCT
                                </option>

                                <option value={S2}>
                                    Invalidez - Art. 212 LCT
                                </option>

                                <option value={S3}>
                                    Enfermedad y/o accidente inculpable
                                </option>

                                <option value={S4}>
                                    Denuncia de siniestro por fallecimiento
                                </option>

                                <option value={S5}>
                                    Denuncia de siniestro por desempleo
                                </option>

                                <option value={S6}>
                                    UIF - Persona humana
                                </option>

                                <option value={S7}>
                                    UIF - Personas jurídicas
                                </option>

                                <option value={S8}>
                                    Denuncia de siniestro por maternidad
                                </option>

                                <option value={S9}>
                                    Seguro colectivo de vida obligatorio
                                </option>

                                <option value={S10}>
                                    Información por siniestro - UIF
                                </option>

                                <option value={S11}>
                                    Denuncia de siniestro - Seguros de personas
                                </option>

                                <option value={S12}>
                                    Denuncia de siniestro - Vida con ahorro
                                </option>

                                <option value={S13}>
                                    Declaración jurada del beneficiario
                                </option>

                            </Form.Control>

                            <a
                                className={`download-button ${!formsS ? 'disabled' : ''}`}
                                href={formsS || '#'}
                                download
                            >
                                <FontAwesomeIcon icon="download" />
                                Descargar formulario
                            </a>

                        </div>


                        {/* INVERSIONES */}

                        <div className="form-card">

                            <span className="form-number">
                                02
                            </span>

                            <h3>
                                Inversiones
                            </h3>

                            <p className="form-card-description">
                                Formularios relacionados con el seguro
                                de vida con ahorro.
                            </p>

                            <label className="form-select-label">
                                Seleccioná un formulario
                            </label>

                            <Form.Control
                                as="select"
                                value={formsI}
                                onChange={(e) => setFormsI(e.target.value)}
                            >

                                <option value="">
                                    Seleccioná una opción...
                                </option>

                                <option value={I1}>
                                    Solicitud de rescate - Vida con ahorro
                                </option>

                            </Form.Control>

                            <a
                                className={`download-button ${!formsI ? 'disabled' : ''}`}
                                href={formsI || '#'}
                                download
                            >
                                <FontAwesomeIcon icon="download" />
                                Descargar formulario
                            </a>

                        </div>


                        {/* EMISIÓN */}

                        <div className="form-card form-card-wide">

                            <div className="form-card-inner">

                                <span className="form-number">
                                    03
                                </span>

                                <h3>
                                    Emisión
                                </h3>

                                <p className="form-card-description">
                                    Formularios necesarios para la emisión
                                    y administración de pólizas.
                                </p>

                                <label className="form-select-label">
                                    Seleccioná un formulario
                                </label>

                                <Form.Control
                                    as="select"
                                    value={formsE}
                                    onChange={(e) => setFormsE(e.target.value)}
                                >

                                    <option value="">
                                        Seleccioná una opción...
                                    </option>

                                    <option value={E1}>
                                        Declaración jurada - Persona políticamente expuesta
                                    </option>

                                    <option value={E2}>
                                        Asegurados tomadores - RG 126/2023
                                    </option>

                                    <option value={E3}>
                                        Tomadores asegurados - Personas jurídicas
                                    </option>

                                    <option value={E3A}>
                                        Personas jurídicas - Anexo
                                    </option>

                                    <option value={E4}>
                                        Información a asegurados - Organismos públicos
                                    </option>

                                    <option value={E5}>
                                        Formulario de beneficiarios
                                    </option>

                                    <option value={E6}>
                                        Seguro de vida obligatorio - Solicitud de póliza
                                    </option>

                                    <option value={E7}>
                                        SCV - Adhesión y designación de beneficiarios
                                    </option>

                                    <option value={E8}>
                                        DDJJ sujeto obligado - Resolución 126/2023 UIF
                                    </option>

                                    <option value={E12}>
                                        Solicitud afiliación - Vida con ahorro
                                    </option>

                                    <option value={E15}>
                                        Declaración jurada del pagador de la póliza
                                    </option>

                                </Form.Control>

                                <a
                                    className={`download-button ${!formsE ? 'disabled' : ''}`}
                                    href={formsE || '#'}
                                    download
                                >
                                    <FontAwesomeIcon icon="download" />
                                    Descargar formulario
                                </a>

                            </div>

                        </div>

                    </div>

                </div>

            </Div>

        </Layout>
    );
}




// import React, { useState } from 'react'
// import Layout from '../components/layout'
// import { Form } from 'react-bootstrap'

// import S1 from '../assets/files/FCE - SIN - 01 - DENUNCIA DE SINIESTRO POR FALLECIMIENTO - ART_ 248 LCT.pdf'
// import S2 from '../assets/files/FCE - SIN - 02 - DENUNCIA DE SINIESTRO POR INVALIDEZ - ART_ 212 LCT.pdf'
// import S3 from '../assets/files/FCE - SIN - 03 - ENFERMEDAD Y-O ACCIDENTE INCULPABLE.pdf'
// import S4 from '../assets/files/FCE - SIN - 04 - DENUNCIA DE SINIESTRO POR FALLECIMIENTO.pdf'
// import S5 from '../assets/files/FCE - SIN - 05 - DENUNCIA DE SINIESTRO POR DESEMPLEO.pdf'
// import S6 from '../assets/files/FCE - SIN - 06 - UIF - PERSONA HUMANA.pdf'
// import S7 from '../assets/files/FCE - SIN - 07 - UIF - PERSONAS JURIDICAS.pdf'
// import S8 from '../assets/files/FCE - SIN - 08 - DENUNCIA DE SINIESTRO POR MATERNIDAD.pdf'
// import S9 from '../assets/files/FCE - SIN - 09 - SEGURO COLECTIVO DE VIDA OBLIGATORIO.pdf'
// import S10 from '../assets/files/FCE - SIN - 10 - INFORMACION POR SINIESTRO RG 126 - 2023 - UIF.pdf'
// import S11 from '../assets/files/FCE - SIN - 11 - DENUNCIA DE SINIESTRO SEGUROS DE PERSONAS.pdf'
// import S12 from '../assets/files/FCE - SIN - 12 - DENUNCIA DE SINIESTRO DE VIDA CON AHORRO.pdf'
// import S13 from '../assets/files/FCE - SIN - 13 - DECLARACION JURADA DEL BENEFICIARIO - CESIONARIO.pdf'

// import I1 from '../assets/files/FCE - INV - 01 - SOLICITUD DE RESCATE - VIDA CON AHORRO.pdf'

// import E1 from '../assets/files/FCE - EMI - 01 - DECLARACION JURADA PERSONA POLITICAMENTE EXPUESTA_V02.pdf'
// import E2 from '../assets/files/FCE - EMI - 02 - ASEGURADOS TOMADORES RG 126_2023 - U.I.F._V02.pdf'
// import E3 from '../assets/files/FCE - EMI - 03 - TOMADORES ASEGURADOS RG 126_2023 - U.I.F. - PERSONAS JURIDICAS_PRINCIPAL.pdf'
// import E3A from '../assets/files/FCE - EMI - 03 - TOMADORES ASEGURADOS RG 126_2023 - U.I.F. - PERSONAS JURIDICAS - ANEXO.pdf'
// import E4 from '../assets/files/FCE - EMI - 04 - INFORMACION A ASEGURADOS RG 126-2023 U.I.F. - ORGANISMOS PUBLICOS.pdf'
// import E5 from '../assets/files/FCE - EMI - 05 - FORMULARIO DE BENEFICIARIOS.pdf'
// import E6 from '../assets/files/FCE - EMI - 06 - SEGURO DE VIDA OBLIGATORIO - SOLICITUD DE POLIZA.pdf'
// import E7 from '../assets/files/FCE - EMI - 07 - SCV - ADHESION Y DESIGNACION DE BENEFICIARIOS.pdf'
// import E8 from '../assets/files/FCE - EMI - 08 - DDJJ SUJETO OBLIGADO - RESOLUCION 126-2023 U.I.F..pdf'
// import E12 from '../assets/files/FCE - EMI - 12 - SOLICITUD AFILIACION VIDA CON AHORRO.pdf'
// import E15 from '../assets/files/FCE - EMI - 15 - DECLARACION JURADA DEL PAGADOR DE LA POLIZA.pdf'

// export default function Forms()  {

//     const [ formsS, setFormsS ] = useState('')
//     const [ formsI, setFormsI ] = useState('')
//     const [ formsE, setFormsE ] = useState('')


//     function handleClickS(e) {
//         var form = setFormsS( form = e.target.value )
//         return form;
//     }

//     function handleClickI(e) {
//         var form = setFormsI( form = e.target.value )
//         return form;
//     }

//     function handleClickE(e) {
//         var form = setFormsE( form = e.target.value )
//         return form;
//     }

    
//     return(
//         <Layout>
//             <div className="container-xl p-0">

//                 <div className="px-2 px-lg-0">

//                     <div className="pl-2 text-lg-left">
//                         <h3 className="pt-3 text-lg-left text-company"><b>Formularios</b></h3>
//                         <hr />
//                         <p><strong>IMPORTANTE!</strong> Los formularios pueden editarse digitalmente.</p>
//                         <p>La entrega del formulario debe efectuarse:</p>
//                         <ul className="px-5 px-lg-4 text-left">
//                             <li>en digital</li>
//                             <li>debe estar impreso en doble faz</li>
//                             <li>debe presentarse debidamente firmado sin tachaduras ni enmiendas</li>
//                         </ul>
//                     </div>

//                     <Form.Group className="py-2" controlId="exampleForm.ControlSelect2">
//                         <Form.Label className="d-block text-center">Formularios de Siniestros</Form.Label>
//                         <Form.Control as="select" onChange={handleClickS}>
//                             <option></option>
//                             <option value={S1}>FCE - SIN - 01 - DENUNCIA DE SINIESTRO POR FALLECIMIENTO - ART_ 248 LCT</option>
//                             <option value={S2}>FCE - SIN - 02 - DENUNCIA DE SINIESTRO POR INVALIDEZ - ART_ 212 LCT</option>
//                             <option value={S3}>FCE - SIN - 03 - DENUNCIA DE SINIESTRO POR ENFERMEDAD Y-O ACCIDENTE INCULPABLE</option>
//                             <option value={S4}>FCE - SIN - 04 - DENUNCIA DE SINIESTRO POR FALLECIMIENTO - ART_ 27</option>
//                             <option value={S5}>FCE - SIN - 05 - DENUNCIA DE SINIESTRO POR DESEMPLEO</option>
//                             <option value={S6}>FCE - SIN - 06 - UIF - PERSONA HUMANA</option>
//                             <option value={S7}>FCE - SIN - 07 - UIF - PERSONAS JURIDICAS</option>
//                             <option value={S8}>FCE - SIN - 08 - DENUNCIA DE SINIESTRO POR MATERNIDAD</option>
//                             <option value={S9}>FCE - SIN - 09 -SEGURO COLECTIVO DE VIDA OBLIGATORIO</option>
//                             <option value={S10}>FCE - SIN - 10 - INFORMACION POR SINIESTRO RG 126 - 2023 - UIF</option>
//                             <option value={S11}>FCE - SIN - 11 - DENUNCIA DE SINIESTRO SEGUROS DE PERSONAS</option>
//                             <option value={S12}>FCE - SIN - 12 - DENUNCIA DE SINIESTRO DE VIDA CON AHORRO</option>
//                             <option value={S13}>FCE - SIN - 13 - DECLARACION JURADA DEL BENEFICIARIO - CESIONARIO</option>
//                         </Form.Control>

//                         <a className="border-0 p-2 btn-block btn-blue text-center text-light" href={formsS} download target="_parent">Descargar formulario</a>
//                     </Form.Group>

//                     <hr/>

//                     <Form.Group className="py-2">
//                         <Form.Label className="d-block text-center">Formularios de Inversiones</Form.Label>
//                         <Form.Control as="select" onChange={handleClickI}>
//                             <option></option>
//                             <option value={I1}>FCE - INV - 01 - SOLICITUD DE RESCATE - VIDA CON AHORRO</option>
//                         </Form.Control>

                        
//                         <a className="border-0 p-2 btn-block btn-blue text-center text-light" href={formsI} download>Descargar formulario</a>
//                     </Form.Group>

//                     <hr/>

//                     <Form.Group className="py-2">
//                         <Form.Label className="d-block text-center">Formularios de Emisión</Form.Label>
//                         <Form.Control as="select" onChange={handleClickE}>
//                             <option></option>
//                             <option value={E1}>FCE - EMI - 01 - DECLARACION JURADA PERSONA POLITICAMENTE EXPUESTA</option>
//                             <option value={E2}>FCE - EMI - 02 - ASEGURADOS TOMADORES RG 126_2023 - U.I.F.</option>
//                             <option value={E3}>FCE - EMI - 03 - TOMADORES ASEGURADOS RG 126_2023 - U.I.F. - PERSONAS JURIDICAS_PRINCIPAL.pdf</option>
//                             <option value={E3A}>FCE - EMI - 03 - TOMADORES ASEGURADOS RG 126_2023 - U.I.F. - PERSONAS JURIDICAS - ANEXO.pdf</option>
//                             <option value={E4}>FCE - EMI - 04 - INFORMACION A ASEGURADOS RG 126-2023 U.I.F. - ORGANISMOS PUBLICOS</option>
//                             <option value={E5}>FCE - EMI - 05 - FORMULARIO DE BENEFICIARIOS</option>
//                             <option value={E6}>FCE - EMI - 06 - SEGURO DE VIDA OBLIGATORIO - SOLICITUD DE POLIZA</option>
//                             <option value={E7}>FCE - EMI - 07 - SCV - ADHESION Y DESIGNACION DE BENEFICIARIOS</option>
//                             <option value={E8}>FCE - EMI - 08 - DDJJ SUJETO OBLIGADO - RESOLUCION 126-2023 U.I.F.</option>
//                             <option value={E12}>FCE - EMI - 12 - SOLICITUD AFILIACION VIDA CON AHORRO</option>
//                             <option value={E15}>FCE - EMI - 15 - DECLARACION JURADA DEL PAGADOR DE LA POLIZA</option>
//                         </Form.Control>

//                         <a className="border-0 p-2 btn-block btn-blue text-center text-light" href={formsE} download replace>Descargar formulario</a>
//                     </Form.Group>

//                 </div>

//             </div>
//         </Layout>

//     )

// }